import { getView, requireAuth } from '@/lib/utils';
import { AssetsPage } from '@/data/appInformationItems';
import { Left } from 'Models/Menu/menus';

export default {
  path: '/qhse',
  component: getView('pages/PageDosing'),
  name: 'qhse',
  beforeEnter: requireAuth,
  meta: {
    crumbs: 'ANALYTICS - QHSE',
    leftMenu: Left.AnalyticsPage,
    roles: ['operator'],
    information: AssetsPage,
    showBottomMenu: true,
    isFlowChem: false,
    crumbsIcon: 'flow-dosing',
  },
};
